import { GraphQLError } from 'graphql';

import type { BadStatusError } from '@confluence/network';
import { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop';

export const convertToApolloError = (error: Error | BadStatusError): ApolloErrorInterop => {
	const message = error.message || 'Unknown error';
	const status = 'response' in error ? error.response?.status : undefined;

	return new ApolloErrorInterop({
		graphQLErrors: [createGraphQLError({ message, status, originalError: error })],
	});
};

const createGraphQLError = ({
	message,
	status,
	originalError,
}: {
	message: string;
	status: number | undefined;
	originalError: Error;
}) => {
	const extensions = status
		? {
				statusCode: status,
				http: { status },
			}
		: undefined;

	return new GraphQLError(
		message,
		null, // nodes - no GraphQL query AST
		null, // source - no GraphQL query text
		null, // positions - no GraphQL query positions
		null, // path - not executing GraphQL schema fields
		originalError,
		extensions,
	);
};
